import axios, {AxiosResponse} from 'axios'
import {Option} from 'react-multi-select-component'
import {Response} from '../../../../../_metronic/helpers'
import {
  MetricClientsResponse,
  MetricOptions,
  MetricProducts,
  MetricResponse,
  MetricSummary,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const ANALYTICS_URL = `${API_URL}/reports/client-analytics`

const getMetricSummary = (query: string): Promise<MetricResponse<MetricSummary>> => {
  return axios
    .get(`${ANALYTICS_URL}/summary?${query}`)
    .then((d: AxiosResponse<MetricResponse<MetricSummary>>) => d.data)
}

const getMetricProducts = (query: string): Promise<MetricResponse<MetricProducts>> => {
  return axios
    .get(`${ANALYTICS_URL}/products?${query}`)
    .then((d: AxiosResponse<MetricResponse<MetricProducts>>) => d.data)
}

const getMetricClients = (query: string): Promise<MetricClientsResponse> => {
  return axios
    .get(`${ANALYTICS_URL}/clients?${query}`)
    .then((d: AxiosResponse<MetricClientsResponse>) => d.data)
}

const getMetricOptions = (): Promise<MetricOptions> => {
  return axios
    .get(`${ANALYTICS_URL}/options`)
    .then((d: AxiosResponse<{data: MetricOptions}>) => d.data.data)
}

const getHowMetOptions = (): Promise<Option[] | undefined> => {
  return axios
    .get(`${API_URL}/people/how-met-options`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

const getCategories = (): Promise<Option[] | undefined> => {
  return axios
    .get(`${API_URL}/products/categories/all`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

// O relatório é sempre gerado em fila: o backend responde 202 com a mensagem para a área de downloads.
const exportMetricReport = (query: string): Promise<{message: string; id: number}> => {
  return axios
    .get(`${ANALYTICS_URL}/export?${query}`)
    .then((d: AxiosResponse<{message: string; id: number}>) => d.data)
}

export {
  getMetricSummary,
  getMetricProducts,
  getMetricClients,
  getMetricOptions,
  getHowMetOptions,
  getCategories,
  exportMetricReport,
}
